exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-53be8a77]{padding:0;margin:0;margin-bottom:35px;border-bottom:0}h6.head-title[data-v-53be8a77]{margin-bottom:20px;font-size:1.1rem}.modal-footer[data-v-53be8a77]{padding:0;margin-top:18px;border:0}.form-group[data-v-53be8a77]{margin-bottom:3px}.form-settings[data-v-53be8a77]{display:grid;grid-template-columns:1fr 1fr;-webkit-column-gap:4rem;column-gap:4rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53be8a77","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/admin/js/attendance/modals/GridColumnsForm.vue
// module id = pRqj
// module chunks = 0